import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'mobo-partner-banner',
  templateUrl: './partner-banner.component.html',
  styles: [],
})
export class PartnerBannerComponent {
  @Input() hasBtn = true;
  public baseUrl = environment.baseUrl;
}
